import { render, staticRenderFns } from "./ProcessRecord.vue?vue&type=template&id=6c0f5baf&scoped=true&"
import script from "./ProcessRecord.vue?vue&type=script&lang=js&"
export * from "./ProcessRecord.vue?vue&type=script&lang=js&"
import style0 from "./ProcessRecord.vue?vue&type=style&index=0&id=6c0f5baf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f5baf",
  null
  
)

export default component.exports